import { render, staticRenderFns } from "./UsersFamilyList.vue?vue&type=template&id=5e60fae6"
import script from "./UsersFamilyList.vue?vue&type=script&lang=js"
export * from "./UsersFamilyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports